var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "learning-paths",
      class: {
        container: !_vm.mobile,
        mobile: _vm.mobile,
        experiment: _vm.isExperiment
      }
    },
    [
      _c(
        "header",
        { class: { container: _vm.mobile } },
        [
          _vm._t("heading", [_vm._m(0)]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      All of our courses are crafted by award-winning teachers, researchers, and professionals\n      from MIT, Caltech, Duke, Microsoft, Google, and more.\n    "
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "buttonContainer",
          staticClass: "buttons",
          class: { container: _vm.mobile }
        },
        [
          !_vm.mobile
            ? _c(
                "button",
                {
                  staticClass: "prev",
                  class: {
                    visible:
                      _vm.canScrollButtons && _vm.timesScrolledButtons > 0
                  },
                  attrs: { "aria-label": "Previous" },
                  on: {
                    click: function($event) {
                      _vm.timesScrolledButtons -= 1
                    }
                  }
                },
                [_c("span", { staticClass: "b-sprite-landing-chevron" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            {
              ref: "buttons",
              staticClass: "unstyled",
              style: {
                transform: _vm.mobile
                  ? ""
                  : "translateX(-" + _vm.buttonsScrollPosition + "px)"
              }
            },
            _vm._l(_vm.landingLearningPaths, function(path) {
              var _obj
              return _vm.isPathAllowed(path)
                ? _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "track",
                          rawName: "v-track:click",
                          value: {
                            axId: _vm.getPathAxId(path),
                            axType: "button"
                          },
                          expression:
                            "{\n          axId: getPathAxId(path),\n          axType: 'button',\n        }",
                          arg: "click"
                        }
                      ],
                      key: path.slug,
                      class: ((_obj = {}),
                      (_obj[path.slug] = true),
                      (_obj.selected = _vm.isPathSelected(path)),
                      _obj),
                      on: {
                        click: function($event) {
                          _vm.selectedPathSlug = path.slug
                        }
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "icon",
                        class: "b-sprite-landing-path-" + path.slug
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.getLearningPathTitle(path)))
                      ])
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          !_vm.mobile
            ? _c(
                "button",
                {
                  staticClass: "next",
                  class: {
                    visible:
                      _vm.canScrollButtons &&
                      _vm.timesScrolledButtons < _vm.maxButtonScrolls
                  },
                  attrs: { "aria-label": "Next" },
                  on: {
                    click: function($event) {
                      _vm.timesScrolledButtons += 1
                    }
                  }
                },
                [_c("span", { staticClass: "b-sprite-landing-chevron" })]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "contentWrapper", staticClass: "content-wrapper" },
        [
          _c(
            "transition",
            {
              attrs: { name: "fade-fast" },
              on: {
                enter: _vm.onTransitionEnter,
                "after-enter": _vm.resetWrapperHeight
              }
            },
            [
              _vm.selectedPath
                ? _c(
                    "div",
                    { key: _vm.selectedPath.slug, staticClass: "content" },
                    [
                      _c("div", { staticClass: "course-list" }, [
                        _c("h4", { class: { container: _vm.mobile } }, [
                          _vm._v("\n            Courses in "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.getLearningPathTitle(_vm.selectedPath))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "wrapper",
                            class: { container: _vm.mobile }
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "course-names unstyled" },
                              _vm._l(_vm.selectedPath.course_names, function(
                                courseName
                              ) {
                                return _c("li", { key: courseName }, [
                                  !_vm.mobile
                                    ? _c("div", { staticClass: "hexagon" })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "course-name" }, [
                                    _vm._v(_vm._s(courseName))
                                  ])
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "video",
                          class: { container: _vm.mobile }
                        },
                        [
                          _c(
                            "video",
                            {
                              attrs: {
                                preload: "auto",
                                autoplay: "",
                                muted: "",
                                playsinline: "",
                                loop: ""
                              },
                              domProps: { muted: true }
                            },
                            [
                              _c("source", {
                                attrs: {
                                  src: _vm.getLearningPathVideoURL(
                                    _vm.selectedPath
                                  ),
                                  type: "video/mp4"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("\n        See math and science in a\n        "),
      _c("strong", [_vm._v("new way")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }